import {JqStyle} from "@/edinet/libs/jq_style";
import {hasTableWithNf, ixExists, scrollToIx, scrollToTableWithNf, scrollToText, textExists} from "@/edinet/libs/scroll"

export interface Shortcut {
    section: string
    label: string
    shortLabel: string
    f: string | (() => void)
    args?: string[]
    key?: string
}

export const executeFunction = function(shortcut: Shortcut) {
    if (typeof shortcut.f === 'function') {
        shortcut.f()
    } else if (typeof shortcut.f === 'string') {
        if (shortcut.f === 'scrollToIx') {
            if (shortcut.args) {
                scrollToIx(shortcut.args)
            } else {
                console.warn('shortcut function scrollToIx requires .args params')
            }
        } else if (shortcut.f === 'scrollToText') {
            if (shortcut.args) {
                scrollToText(shortcut.args)
            } else {
                console.warn('shortcut function scrollToText requires .args params')
            }
        } else if (shortcut.f === 'scrollToTableWithNf') {
            if (shortcut.args) {
                scrollToTableWithNf(shortcut.args)
            } else {
                console.warn('shortcut function scrollToTableWithNf requires .args params')
            }
        } else {
            console.warn('unknown shortcut function: ' + shortcut.f)
        }
    }
}

export const checkArgs = function(shortcut: Shortcut): boolean {
    if (typeof shortcut.f === 'string') {
        if (shortcut.f === 'scrollToIx') {
            if (shortcut.args) {
                const res = ixExists(shortcut.args)
                return res
            } else {
                console.warn('shortcut function scrollToIx requires .args params')
            }
        } else if (shortcut.f === 'scrollToText') {
            if (shortcut.args) {
                const res = textExists(shortcut.args)
                return res
            } else {
                console.warn('shortcut function scrollToText requires .args params')
            }
        } else if (shortcut.f === 'scrollToTableWithNf') {
            if (shortcut.args) {
                const res = hasTableWithNf(shortcut.args)
                return res
            } else {
                console.warn('shortcut function scrollToTableWithNf requires .args params')
            }
        } else {
            console.warn('unknown shortcut function: ' + shortcut.f)
        }
    }
    return true
}

export class ShortcutBuilder {
    shortcuts: Shortcut[]

    constructor(shortcuts: Shortcut[]) {
        this.shortcuts = shortcuts
    }

    onToggleHints(f: () => void) {
        this.setHandler('x', f)
    }

    onToggleIxToc(f: () => void) {
        this.setHandler('X', f)
    }

    onToggleHelp(f: () => void) {
        this.setHandler('?', f)
    }

    onToggleHighlight(f: () => void) {
        this.setHandler('h', f)
    }

    onClose(f: () => void) {
        this.setHandler('Escape', f)
    }

    setStyleShortcut(jqStyle: JqStyle) {
        this.setHandler('=', () => jqStyle.fontUp())
        this.setHandler('-', () => jqStyle.fontDown())
        this.setHandler('>', () => jqStyle.widthUp())
        this.setHandler('<', () => jqStyle.widthDown())
    }

    setHandler(key: string, f: () => void) {
        const res = this.shortcuts.find(x => x.key === key)
        if (res) {
            res.f = f
        } else {
            console.warn(`handler for key '${key}' not found`)
        }
    }

    getSection(section: string): Shortcut[] {
        return this.shortcuts.filter(x => x.section === section)
    }

    setupKeyboardBinding() {
        //keyboard
        console.log('setting up keyboard binding...')
        document.onkeydown = (e) => {
            // console.log(document.activeElement)
            if ((document.activeElement?.tagName === 'BODY'
                || document.activeElement?.tagName === 'A'
                || document.activeElement?.tagName === 'BUTTON')
                && !e.metaKey) { //do not activate shortcut if command is pressed
                const shortcut = this.shortcuts.find(x => x.key === e.key)
                if (shortcut) {
                    console.debug(e)
                    executeFunction(shortcut)
                } else {
                    //console.trace('no shortcut for key %o', e.key)
                }
            }
        }
    }

    //v2 - let the caller execute the shortcut so we can do something in the UI
    setupKeyboardBinding2(startFunc: (_: Shortcut, executeFunction: () => void) => void) {
        //keyboard
        console.log('setting up keyboard binding...')
        document.onkeydown = (e) => {
            // console.log(document.activeElement)
            if ((document.activeElement?.tagName === 'BODY'
                || document.activeElement?.tagName === 'A'
                || document.activeElement?.tagName === 'BUTTON')
                && !e.metaKey) { //do not activate shortcut if command is pressed
                const shortcut = this.shortcuts.find(x => x.key === e.key)
                if (shortcut) {
                    startFunc(shortcut, () => executeFunction(shortcut))
                    // console.debug(e)
                } else {
                    //console.trace('no shortcut for key %o', e.key)
                }
            }
        }
    }
}